import {Routes} from '@angular/router';
import {AuthLayoutComponent} from "./layouts/auth-layout/auth-layout.component";
import {ForgotPasswordLayoutComponent} from "./layouts/forgot-password-layout/forgot-password-layout.component";
import {DashboardLayoutComponent} from "./layouts/dashboard-layout/dashboard-layout.component";
import {authGuard} from "./core/guards/auth.guard";
import _default from "chart.js/dist/core/core.interaction";


export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'auth',
        pathMatch: 'full',
    },
    {
        path: 'auth',
        component: AuthLayoutComponent,
        loadChildren: () => import('./pages/auth/auth.module').then(x => x.AuthModule)
    },
    {
        path: 'forgot',
        component: ForgotPasswordLayoutComponent,
        loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(x => x.ForgotPasswordModule)
    },
    {
        path: 'administration',
        component: DashboardLayoutComponent,
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        data: {
            breadcrumb: 'Administration',
        },
        loadChildren: () => import("./pages/administration/admin-routes")
    },

    {
        path: '**',
        redirectTo: 'auth'
    }
]
